import { createFileRoute } from "@tanstack/react-router"
import { Page } from "@/components/page"
import { Typography } from "@/components/ui/typography"

export const Route = createFileRoute("/_authed/_individual/personal/journals")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Page
      headerSlot={
        <Typography as="h1" size="2xl">
          Journals
        </Typography>
      }
    >
      Journals page
    </Page>
  )
}
